import React from 'react'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { EmptyNode } from 'common/builder/components/chart/FlowChart/components/EmptyNode/EmptyNode'
import { FlowChartEmptyNodeBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartEmptyNodeBlock'

export const EmptyNodeBlock: BlockComponent<FlowChartEmptyNodeBlock> = ({
  block: {
    id,
    data: { text, icon: IconComponent },
  },
}) => {
  return <EmptyNode id={id} iconComponent={IconComponent} text={text} />
}
